module.exports = __webpack_public_path__ + "images/6e02fc2335c3f404bc3e656f568fd95e7.svg";